<template>
  <div class="public-content sales-message">
    <div class="breadcrumb">业务主管信息</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="业务主管:">
              <el-input v-model="formInline.fullName" placeholder="请输入主管姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号:">
              <el-input v-model="formInline.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <el-button class="search-ok" @click="exportExcel" v-if="$hasPermission('crm:admin:supervisor:export')" v-permission="'crm:admin:supervisor:export'" round>导出Excel </el-button>
            <el-button class="search-ok" @click="dialogVisible = true" v-if="$hasPermission('crm:admin:supervisor:promote')" v-permission="'crm:admin:supervisor:promote'" round type="primary">添加业务主管
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="业务主管" min-width="10px">
            <template v-slot="scope">
              <span class="color-blue" v-if="$hasPermission('crm:admin:supervisor:update')" @click="goBasic(scope.row)">{{ scope.row.fullName }}</span>
              <span v-else>{{ scope.row.fullName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="10px"></el-table-column>
          <!-- <el-table-column prop="address.completeAddress" label="地址" min-width="10"></el-table-column> -->
          <el-table-column prop="registerTime" label="创建日期" min-width="10"></el-table-column>
          <el-table-column label="业务数量" min-width="10px">
            <template v-slot="scope">
              <span v-if="$hasPermission('crm:admin:supervisor:salesmesList')" class="color-blue" @click="relatedPlatforms(scope.row)">{{ scope.row.salesCount }}</span>
              <span v-else>{{ scope.row.salesCount }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
    <!-- 添加业务 -->
    <el-dialog :close-on-click-modal="false" :title="title" @closed='close' :visible.sync="dialogVisible" width="30%">
      <p style="color:#666;font-weight: bold;padding-left:28px;margin-bottom:15px" v-show="hasUser === 200">添加成员成功，已将账号信息以短信形式发送</p>
      <p style="color:#666;font-weight: bold;padding-left:28px;margin-bottom:15px" v-show="hasUser === 201">添加成员成功</p>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item v-show="hasUser === 200" label="手机号：">
          <span>{{ form.userName }}</span>
        </el-form-item>
        <el-form-item v-show="hasUser === 200" label="密码：">
          <span>{{ form.password }}</span>
        </el-form-item>
        <el-form-item v-show="hasUser !== 200 && hasUser !== 201" label="手机号：">
          <el-input v-model="form.phone" style="width:200px"></el-input>
          <el-button type="primary" @click="checkUser" round>查询</el-button>
        </el-form-item>
        <el-form-item label="姓名：" v-show="hasUser === 0">
          <el-input v-model="form.fullName" style="width:200px" maxlength="10"></el-input>
        </el-form-item>
      </el-form>
      <el-table v-show="hasUser === 1" :data="tableData1" style="width: 95%">
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="fullName" label="客户姓名"></el-table-column>
        <el-table-column prop="roleName" label="角色名称"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-show="hasUser !== 200 && hasUser !== 201" @click="addSale" v-preventReClick>添加</el-button>
        <el-button type="primary" v-show="hasUser === 201" @click="dialogVisible = false" v-preventReClick>确定</el-button>
        <el-button type="primary" v-show="hasUser === 200" @click="copy">复制信息</el-button>
      </span>
    </el-dialog>
    <input style="position: absolute;top: 0;left: 0;opacity: 0;z-index: -10;" type="text" id="copy" v-model="copyText">
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { getSalesmanManegerList, salesmanManagerExport, checkPhone, salesmanManager, addSalemanManager } from '@/api/crm'
export default {
  name: 'sales-message',
  components: {
    VPagination,
    CombinedDialog
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)
        if (val) {
          this.formInline.registerTimeBegin = val[0]
          this.formInline.registerTimeEnd = val[1]
        } else {
          this.formInline.registerTimeBegin = ''
          this.formInline.registerTimeEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      isCheck: false,
      dialogVisible: false,
      hasUser: '',
      title: '添加业务主管',
      tableData1: [],
      form: {},
      formInline: {
        fullName: '',
        registerTimeBegin: '',
        registerTimeEnd: '',
        phone: '',
        salesmanManager: 1
      },
      tableData: [{
        salesman: '29828239888',
        phone: '',
        address: '',
        createDate: '',
        count: 2
      }],
      value2: [
        // this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        // this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      copyText: ''
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.value2 = [this.formInline.registerTimeBegin, this.formInline.registerTimeEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    this.getSalesman(this.queryInfo)
  },
  // 离开列表页销毁标识
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    goBasic (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/supervisorMsgDetails', query: { id: row.id } })
    },
    // 关联业务
    relatedPlatforms (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/relatedBusiness', query: { id: row.id, fullName: row.fullName } })
    },
    close () {
      this.hasUser = ''
      this.form = {}
      this.title = '添加业务主管'
      this.onSubmit()
    },
    beforeClose (done) {
      this.hasUser = ''
      this.form = {
        phone: '',
        fullName: ''
      }
      done()
    },
    copy () {
      console.log('copyText', this.copyText)
      var copyobject = document.getElementById('copy')
      copyobject.select()
      document.execCommand('Copy')
      this.$message.success('复制成功')
      this.dialogVisible = false
      this.onSubmit()
    },
    async addSale () {
      if (!this.isCheck) {
        this.$message.error('请先查询')
        return false
      } else if (this.hasUser === 1) {
        await salesmanManager(this.tableData1[0].userId).then(res => {
          if (res.data.success) {
            this.title = '确认提示'
            this.hasUser = 201
          }
        })
      } else if (this.hasUser === 0) {
        if (!this.form.phone || !this.form.fullName) {
          this.$message.error('信息不完整')
          return
        }
        await addSalemanManager(this.form).then(res => {
          if (res.data.success) {
            this.title = '确认信息'
            this.hasUser = 200
            this.form = res.data.data
            this.form.userName = this.$msg.filterBridal(res.data.data.userName)
            this.form.phone = this.$msg.filterBridal(res.data.data.phone)
            this.copyText = '手机号：' + res.data.data.userName + ';密码：' + res.data.data.password
            console.log('this.copyText', this.copyText)
            this.$forceUpdate()
          }
        })
      }
      this.onSubmit()
    },
    checkUser () {
      checkPhone(this.form.phone, true).then(res => {
        if (res.data.success) {
          if (res.data.data.exist) {
            res.data.data.phone = this.$msg.filterBridal(res.data.data.phone)
            res.data.data.roleName = (res.data.data.salesmanManage) ? '业务主管' : res.data.data.roleName
            this.tableData1 = [res.data.data]
            this.hasUser = 1
          } else {
            this.hasUser = 0
          }
        }
        this.isCheck = true
      })
    },
    getSalesman (val) {
      getSalesmanManegerList({ pageNum: val.pageNum, pageSize: val.pageSize, salesmanVo: this.formInline }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.records.map(a => {
            if (a.phone) {
              a.phone = this.$msg.filterBridal(a.phone)
            }
            return a
          })
          this.queryInfo.total = res.data.data.total
          // this.queryInfo.total = res.data.data.total
        } else {
        }
      })
    },
    onSubmit () {
      this.getSalesman(this.queryInfo)
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      salesmanManagerExport(this.formInline).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          let _fileName = '业务主管信息表' + '.xls'
          if (this.value2.length) {
            _fileName = '业务主管信息表' + this.value2[0] + '-' + this.value2[1] + '.xls'
          }
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getSalesman(this.queryInfo)
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}
</style>
